<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-directions</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("travelService.types.other") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.otherServiceType") }}: {{ travelServiceOrderItem.params }}<br />
    </div>
    <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
  </v-tooltip>
</template>

<script>
import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";
export default {
  name: "TravelServiceOrderItemOtherChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa wynajmu pojazdów" }
  }
};
</script>

<style scoped></style>
